module.exports = __webpack_public_path__ + "static/img/img-16.3ff9a18.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/i/img-16.jpg
// module id = 99
// module chunks = 0